export default __webpack_public_path__ + "static/media/Clubhouse - Resident Lounge- Person Drinking Coffee.12d14b62.jpg";